import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { SelectItemTypes } from "../../CommonTypes";
import { FullAWSDataRow } from "./SetupAwarenessTypes";
import { InputGroupPropsTypes } from "../inputComp/InputGroupType";
import { CalenderIcon, CloseIcon, DescriptionIcon, IdIcon, NameIcon, SearchIcon } from "../iconSet/IconSet";
import InputGroup from "../inputComp/InputGroup";
import MultipleDragDropUpload from "../inputComp/MultipleDragDropUpload";
import MultipleVideoUpload from "../inputComp/MultipleVideoUpload";
import AlertDialog from "../popupComp/AlertDialog";
import { useUserData } from "../../context/UserDataContext";

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useTheme } from "../../context/ThemeContext";
import { warningMap } from "../createWarningComp/FixedDataSet";
import LoadingScreen from "../loadingScreenComp/LoadingScreen";


interface NewsForm {
	newsid: string;
	n_head: string;
	n_body: string;
	tag: string;
	date: string;
	username: string;
	//priority: string;
	n_headbg: string;
	n_bodybg: string;
	n_headta: string;
	n_bodyta: string;
	video_autoplay: string;
}

const SetupAwareness: React.FC = () => {
	const BASE_URL = process.env.REACT_APP_BASE_URL;

	const { theme } = useTheme()
	const { username } = useUserData()

	const [form, setForm] = useState<NewsForm>({
		newsid: "",
		n_head: "",
		n_body: "",
		tag: "",
		date: "",
		username: "",
		//priority: "",
		n_headbg: "",
		n_bodybg: "",
		n_headta: "",
		n_bodyta: "",
		video_autoplay: "false",
	});

	const [images, setImages] = useState<File[]>([]);
	const [thumbnails, setThumbnails] = useState<File[]>([]);
	const [videos, setVideos] = useState<File[]>([]);

	const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null);

	const [isDataPickerLoading, setIsDataPickerLoading] = useState<boolean>(false);

	const [isLoading, setIsLoading] = useState<boolean>(false)

	const handleImageClick = (url: string) => {
		setSelectedImageUrl(url);
	};

	// Hazards
	const [selectHazard, setSelectHazard] = useState<SelectItemTypes[]>([
		{ value: "LSW", name: "Landslide" },
		{ value: "FLW", name: "Flood" },
		{ value: "HRW", name: "Heavy Rain" },
		//{ value: "EW", name: "Explosion" },
		//{ value: "TW", name: "Tsunami" },
		//{ value: "BHW", name: "Biological Hazard" },
		//{ value: "FW", name: "Fire" },
		//{ value: "CW", name: "Cyclone" },
		//{ value: "WFW", name: "Wild Fire" },
		//{ value: "EQW", name: "Earthquake" },
		{ value: "HWN", name: "High Wind" },
		{ value: "SAN", name: "Marine Weather" },
		//{ value: "NTW", name: "Nuclear Threat" },
		//{ value: "ASW", name: "Air Strike" },
		{ value: "LIG", name: "Lightning" },
		//{ value: "CUS", name: "Custom warning" },
	]);

	const [alertDialogState, setAlertDialogState] = useState(false);
	const [alertTitle, setAlertTitle] = useState("");
	const [alertDescription, setAlertDescription] = useState("");
	const [alertCallback, setAlertCallback] = useState<() => void | undefined>();

	const [alertYesCallback, setAlertYesCallback] = useState<
		(() => void) | undefined
	>(undefined); // for Yes
	const [alertOkCallback, setAlertOkCallback] = useState<
		(() => void) | undefined
	>(undefined); // for OK

	const showAlertDialog = (
		title: string,
		description: string,
		yesCallback?: () => void,
		okCallback?: () => void
	) => {
		setAlertTitle(title);
		setAlertDescription(description);
		setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
		setAlertOkCallback(() => okCallback); // Will trigger only on OK
		setAlertDialogState(true);
	};

	const [isUpdate, setIsUpdate] = useState(false);
	const [isDataPickerOpen, setIsDataPickerOpen] = useState<boolean>(false);

	const allAws = useRef<FullAWSDataRow[]>([]);

	const [filteredData, setFilteredData] = useState<FullAWSDataRow[]>([]);

	const getAwsNextId = () => {
		const token = localStorage.getItem("access_token");
		fetch(BASE_URL + "/news/api/v1/newAWSSeq", {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		})
			.then(async (res) => {
				if (!res.ok) {
					// handle unauthorized
					if (res.status === 401) {
						console.error("Unauthorized: Token is invalid or expired");
						// maybe redirect to login
						return;
					}
					throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				if (data?.newsid) {
					setForm((prev) => ({
						...prev,
						newsid: data.newsid,
					}));
				}
			})
			.catch((err) => console.error("Error fetching AWS Seq:", err));
	};


	useEffect(() => {
		getAwsNextId();
	}, []);

	useEffect(() => {
		// const userDetailsString = sessionStorage.getItem("userdetails");
		// if (userDetailsString) {
		//   try {
		//     const userDetails = JSON.parse(userDetailsString);
		//     if (userDetails?.username) {
		//       setForm((prev) => ({
		//         ...prev,
		//         username: username, // ✅ auto-fill username
		//       }));
		//     }
		//   } catch (err) {
		//     console.error("Failed to parse userdetails:", err);
		//   }
		// }
		setForm((prev) => ({
			...prev,
			username: username, // ✅ auto-fill username
		}));
	}, [username]);

	/* const handleChange = (e: any) => {
		const { name, value } = e.target;
		setForm((prev) => ({
			...prev,
			[name]: value,
		}));
	}; */

	const handleChange = (
	e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
) => {
	const { name, value } = e.target;
	setForm((prev) => ({
		...prev,
		[name]: value,
	}));
};

	const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = e.target;
		setForm((prev) => ({
			...prev,
			[name]: checked ? "true" : "false", // ✅ convert to string
		}));
	};

	const handleSubmit = async () => {
		const token = localStorage.getItem("access_token");

		const payload = new FormData();
		Object.entries(form).forEach(([key, value]) => {
			payload.append(key, value);
		});

		console.log("paload: ", payload)

		if(isUpdate){
			payload.append("updateMode", "updatemode");
		}
		
		// ✅ Keep list: only names of files that should remain
		const keepImages = images.map((f) => {
			if (typeof f === "string") {
				return (f as string).split("/").pop()!; // URL → filename
			} else {
				return (f as File).name;                // File → filename
			}
		});

	const keepVideos = videos.map((f) => {
		if (typeof f === "string") {
			return (f as string).split("/").pop()!;
		} else {
			return (f as File).name;
		}
	});
		
		console.log(">>>>keepImages ",keepImages)
		console.log(">>>>keepVideos ",keepVideos)

		console.log(">>>>keepImages215 ",keepImages.join(","))
		console.log(">>>>keepVideos216 ",keepVideos.join(","))

		payload.append("keepImages", keepImages.join(","));
		payload.append("keepVideos", keepVideos.join(","));


		// ✅ Append only new uploads (File objects)
		/* images
			.filter((f) => f instanceof File)
			.forEach((file) => payload.append("image_slist", file as File)); */

		/* videos
			.filter((f) => f instanceof File)
			.forEach((file) => payload.append("video_slist", file as File));  */
		

		images.forEach((file) => payload.append("image_slist", file));
		//thumbnails.forEach((file) => payload.append("thumbnail", file));
		videos.forEach((file) => payload.append("video_slist", file));

		setIsLoading(true)

		try {
			const res = await fetch(`${BASE_URL}/news/api/v1/sendNews`, {
				method: "POST",
				body: payload,
				headers: {
					Authorization: `Bearer ${token || ""}`,
				},
			});

			if (!res.ok) {
				if (res.status === 401) {
					console.error("Unauthorized: Token invalid or expired");
					showAlertDialog("Unauthorized", "❌ Token invalid or expired.");
					return;
				}
				throw new Error(`HTTP error! Status: ${res.status}`);
			}

			const data = await res.json();
			if (data.result === "success") {
				//showAlertDialog("Success", "News item created successfully.", undefined, () => window.location.reload());
				showAlertDialog("Success" , isUpdate ? "✅ Awareness updated." : "✅ Awareness created.", undefined, () => window.location.reload());
				setForm({
					newsid: "",
					n_head: "",
					n_body: "",
					tag: "",
					date: "",
					username: "",
					//priority: "",
					n_headbg: "",
					n_bodybg: "",
					n_headta: "",
					n_bodyta: "",
					video_autoplay: "false",
				});
				setImages([]);
				//setThumbnails([]);
				setVideos([]);
			} else {
				showAlertDialog("Error", "❌ Failed to create news item.");
			}
		} catch (err) {
			console.error("Error:", err);
			showAlertDialog("Error", "❌ Something went wrong while sending the news.");
		}
		finally {
			setIsLoading(false)
		}
	};


	const handleDeleteAws = async () => {
		const token = localStorage.getItem("access_token");

		const payload = new FormData();
		Object.entries(form).forEach(([key, value]) => {
			payload.append(key, value);
		});

		console.log("paload: ", payload);

		images.forEach((file) => payload.append("image_slist", file));
		//thumbnails.forEach((file) => payload.append("thumbnail", file));
		videos.forEach((file) => payload.append("video_slist", file));

		setIsLoading(true)
		try {
			const res = await fetch(`${BASE_URL}/news/api/v1/removeNews`, {
				method: "POST",
				body: payload,
				headers: {
					Authorization: `Bearer ${token || ""}`,
				},
			});

			if (!res.ok) {
				if (res.status === 401) {
					console.error("Unauthorized: Token invalid or expired");
					showAlertDialog("Session expired", "❌ Please log in again.");
					return;
				}
				throw new Error(`HTTP error! Status: ${res.status}`);
			}

			const data = await res.json();
			if (data.result === "success") {
				//showAlertDialog("Success", "News item created successfully.", undefined, () => window.location.reload());
				showAlertDialog("Delete", "❌ Awareness deleted.", undefined, () => window.location.reload());
				setForm({
					newsid: "",
					n_head: "",
					n_body: "",
					tag: "",
					date: "",
					username: "",
					//priority: "",
					n_headbg: "",
					n_bodybg: "",
					n_headta: "",
					n_bodyta: "",
					video_autoplay: "false",
				});
				setImages([]);
				//setThumbnails([]);
				setVideos([]);
			} else {
				showAlertDialog("Error", "❌ Failed to delete news item.");
			}
		} catch (err) {
			console.error("Error:", err);
			showAlertDialog("Error", "❌ Something went wrong while deleting the news.");
		}
		finally
		{
			setIsLoading(false)
		}
	};


	const formItems: InputGroupPropsTypes[] = [
		{
			type: "text",
			icon: <NameIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "AWS Id",
			label: "AWS Id",
			name: "newsid",
			onChange: handleChange,
			value: form.newsid,
			required: true,
			dataPicker: true,
			isDataPickerOpen: isDataPickerOpen,
			setIsDataPickerOpen: setIsDataPickerOpen,
			disabled: true,
		},
		{
			type: "text",
			icon: <NameIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "News Head - English",
			label: "News Head - English",
			name: "n_head",
			onChange: handleChange,
			value: form.n_head,
			required: true,
		},
		{
			type: "text-area",
			icon: <DescriptionIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "News Body - English",
			label: "News Body - English",
			name: "n_body",
			onChange: handleChange,
			value: form.n_body,
			required: true,
		},
		{
			type: "text",
			icon: <NameIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "News Head - Bengali",
			label: "News Head - Bengali",
			name: "n_headbg",
			onChange: handleChange,
			value: form.n_headbg,
			required: true,
		},
		{
			type: "text-area",
			icon: <DescriptionIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "News Body - Bengali",
			label: "News Body - Bengali",
			name: "n_bodybg",
			onChange: handleChange,
			value: form.n_bodybg,
			required: true,
		},
		{
			type: "text",
			icon: <NameIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "News Head - Dhivehi",
			label: "News Head - Dhivehi",
			name: "n_headta",
			onChange: handleChange,
			value: form.n_headta,
			required: true,
		},
		{
			type: "text-area",
			icon: <DescriptionIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "News Body - Dhivehi",
			label: "News Body - Dhivehi",
			name: "n_bodyta",
			onChange: handleChange,
			value: form.n_bodyta,
			required: true,
		},
		{
			type: "select-2",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Tag",
			label: "Tag",
			name: "tag",
			optionList: selectHazard,
			onChange: handleChange,
			value: form.tag,
			required: true,
		},
		{
			type: "date-time",
			icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Date",
			label: "Date",
			name: "date",
			onChange: handleChange,
			value: form.date,
			required: true,
		},
		{
			type: "text",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Username",
			label: "Username",
			name: "username",
			onChange: handleChange,
			value: form.username,
			required: true,
			disabled: true,
		} /* 
		{
			type: "text",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Priority",
			label: "Priority",
			name: "priority",
			onChange: handleChange,
			value: form.priority,
		}, */,
	];

	const validateForm = (): boolean => {
		
        const fieldLabels: Record<keyof NewsForm, string> = {
            newsid: "AWS Id",
            n_head: "News Head - English",
            n_body: "News Body - English",
            tag: "Tag",
            date: "Date",
            username: "Username",
            n_headbg: "News Head - Bengali",
            n_bodybg: "News Body - Bengali",
            n_headta: "News Head - Dhivehi",
            n_bodyta: "News Body - Dhivehi",
            video_autoplay: "Video Autoplay",
        };
        const requiredFields: (keyof NewsForm)[] = [
            "newsid",
            "n_head",
            "n_body",
            "tag",
            "date",
            "username",
            "n_headbg",
            "n_bodybg",
            "n_headta",
            "n_bodyta",
        ];
 
        for (const field of requiredFields) {
            if (!form[field] || form[field].trim() === "") {
                showAlertDialog(
                    "Validation Error",
                    `Please fill the ${fieldLabels[field]} field.`
                );
                return false;
            }
        }
 
        // Image / Video validation
        if (!images || images.length === 0) {
            showAlertDialog(
                "Validation Error",
                "Please upload at least one image."
            );
            return false;
        }
 
        // if (!videos || videos.length === 0) {
        //     showAlertDialog(
        //         "Validation Error",
        //         "Please upload at least one video."
        //     );
        //     return false;
        // }
 
        return true;
    };

		const getAllAws = () => {
			setIsDataPickerLoading(true)
			const token = localStorage.getItem("access_token");
			fetch(BASE_URL + "/news/api/v1/getNews", {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(async (res) => {
				if (!res.ok) {
					if (res.status === 401) {
						console.error("Unauthorized: Token invalid or expired");
						showAlertDialog("Unauthorized", "Token invalid or expired.");
						return;
					}
					throw new Error(`HTTP error! Status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				if (data) {
					allAws.current = data;
					//console.log("=================data: ", data);
					setFilteredData(data);
				}
			})
			.catch((err) => console.error("Error fetching roles:", err))
			.finally(() => setIsDataPickerLoading(false))
	};


	useEffect(() => {
		getAllAws();
	}, []);

	const urlToFile = async (url: string, filename: string): Promise<File> => {
		const response = await fetch(url);
		const data = await response.blob();
		return new File([data], filename, { type: data.type });
	};

	const handleClickFilteredNews = (news: FullAWSDataRow) => {
		//console.log("Selected news:", news);

		// format date properly for datetime-local
		let formattedDate = "";
		if (news.date) {
			try {
				const d = new Date(news.date);
				formattedDate = d.toISOString().slice(0, 16);
			} catch (e) {
				console.error("Invalid date:", news.date, e);
			}
		}

		// populate form fields with the selected row
		setForm((prev) => ({
			...prev,
			newsid: news.newsid,
			n_head: news.n_head,
			n_body: news.n_body,
			tag: news.tag,
			date: formattedDate,
			username: news.username,
			n_headbg: news.n_headbg,
			n_bodybg: news.n_bodybg,
			n_headta: news.n_headta,
			n_bodyta: news.n_bodyta,
			video_autoplay: news.video_autoplay,
		}));

		// ✅ handle images
		if (news.image_url) {
			const imageUrls = news.image_url.split(",").map(
				(img) =>
					`${BASE_URL}/static_resource/api/v1/files/RPCUPLOADS/${news.newsid}/${img.trim()}`
			);

			Promise.all(
				imageUrls.map((url) => urlToFile(url, url.split("/").pop() || "file"))
			).then((files) => setImages(files));
		}else {
			setImages([]);
		}

		// ✅ handle videos
		if (news.video_url) {
			const videoUrls = news.video_url.split(",").map(
				(vid) =>
					`${BASE_URL}/static_resource/api/v1/files/RPCUPLOADS/${
						news.newsid
					}/${vid.trim()}`
			);
			Promise.all(
				videoUrls.map((url) => urlToFile(url, url.split("/").pop() || "file"))
			).then((files) => setVideos(files));
		} else {
			setVideos([]);
		}
		setIsUpdate(true)
		setIsDataPickerOpen(false);
	};


	const handleChangeExistingDataSearch = (
		event: ChangeEvent<HTMLInputElement>
	) => {
		if (event.target.value === "") {
			setFilteredData(allAws.current);
		} else {
			setFilteredData(
				allAws.current.filter((item) =>
					item.newsid.toLowerCase().includes(event.target.value.toLowerCase()) ||
					item.n_head.toLowerCase().includes(event.target.value.toLowerCase()) ||
					warningMap.get(item.tag)?.toLowerCase().includes(event.target.value.toLowerCase())
				)
			);
		}
	};

	return (
		<div className="container-wrapper">
			<span className="title">Setup Awareness</span>

			<div className="create-department">
				<div className="grid-layout-create-department">
					<div className={`left-side`}>
						{formItems.slice(0, 7).map((field, index) => (
							<InputGroup key={index} {...field} />
						))}
					</div>

					<div className={`right-side`}>
						{formItems.slice(7).map((field, index) => (
							<InputGroup key={index} {...field} />
						))}
						{/* <div className={`drag-drop-uploader`}>
							<DragDropUpload
								label="Upload Thumbnails"
								files={thumbnails}
								setFile={setThumbnails}
							/>
						</div> */}

						<div className={`drag-drop-uploader`}>
						<MultipleDragDropUpload
								label="Upload Images"
								files={images}
								setFile={setImages}
								folderId= {form.newsid}
								 onImageClick={handleImageClick}
							/>
						</div>

						<div className={`drag-drop-uploader`}>
							<MultipleVideoUpload
								label="Upload Videos"
								files={videos}
								setFile={setVideos}
							/>
						</div>

						<div
							className="checkbox-wrapper"
							style={{ padding: "0 0 1.2rem 1.2rem" }}
						>
							<label
								style={{
									display: "flex",
									alignItems: "center",
									gap: "0.5rem",
									color: "var(--color-text)",
								}}
							>
								<input
									type="checkbox"
									name="video_autoplay"
									checked={form.video_autoplay === "true"}
									onChange={handleCheckboxChange}
								/>
								Enable Video Autoplay
							</label>
						</div>
					</div>
					<div className="button-wrapper" style={{ gridArea: "button" }}>
						<div className="left-side"></div>
						<div className="right-side">
							<button
								className="button-normal"
								//handleDeleteRole()
								onClick={(e) => {
									if (!validateForm()) return;
									showAlertDialog(
										"Confirm Submit",
										"Are you sure you want to submit this awareness?",
										() => handleSubmit()
									) 
								}}
							>
								{isUpdate ? "Update" : "Create"}
							</button>
							{isUpdate && (
								<button className={`button-normal`} style={{backgroundColor: 'var(--color-main-red)'}} onClick={(e) =>
									showAlertDialog(
										"Confirm Delete",
										"Are you sure you want to delete this awareness?",
										() => handleDeleteAws()
									) 
																
								}>Delete</button>
							)}
						</div>
					</div>
					{/* <div className="button-wrapper" style={{ gridArea: "button" }}>
						<div className="left-side"></div>
						<div className="right-side"></div>
						<button
							className="button-normal"
							onClick={(e) => handleSubmit()}
						>Submit</button>
					</div> */}
					{/* <div className="button-wrapper">
						<button className="button-normal" onClick={handleSubmit}>
							Submit
						</button>
					</div> */}

					{isDataPickerOpen && (
						<div className="data-picker-table-wrapper">
							<div className="data-picker-table-container">
								<div className="search-wrapper">
									<input type="text" placeholder="Search awareness" onChange={(e) => handleChangeExistingDataSearch(e)} />
									<div className="search-icon">
										<SearchIcon width="1rem" color="var(--color-main-white)" />
									</div>
									<div className="close-icon" onClick={(e) => setIsDataPickerOpen(false)} >
										<CloseIcon width="1.5rem" color="var(--color-text)" />
									</div>
								</div>

								<div className="row header">
									<span style={{ width: '33%' }}>Awareness Id</span>
									<span style={{ width: '33%' }}>News Head</span>
									<span style={{ width: '33%' }}>Tag</span>
								</div>

								{isDataPickerLoading ? (
									<div className="searching-data">
										<img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
										<span>Searching awareness data...</span>
									</div>
									) : (
										<div className="data-wrapper">
											{filteredData.map((aws, index) => (
												<div key={index} className="row" onClick={(e) => handleClickFilteredNews(aws)}
												>
													<span style={{ width: '33%' }}>{aws.newsid ? aws.newsid : 'N/A'}</span>
													<span style={{ width: '33%' }}>{aws.n_head ? aws.n_head : 'N/A'}</span>
													<span style={{ width: '33%' }}>{warningMap.get(aws.tag) ? warningMap.get(aws.tag) : 'N/A'}</span>
												</div>
											))}
										</div>
									)}
							</div>
						</div>
					)}
				</div>
			</div>
			{alertDialogState && (
				<AlertDialog
					title={alertTitle}
					description={alertDescription}
					windowState={alertDialogState}
					setWindowState={setAlertDialogState}
					function={alertYesCallback}
					okFunction={alertOkCallback}
				/>
			)}
			{selectedImageUrl && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						background: "rgba(0, 0, 0, 0.8)",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						zIndex: 9999,
					}}
					onClick={() => setSelectedImageUrl(null)}
				>
					<img
						src={selectedImageUrl}
						alt="preview"
						style={{
							maxWidth: "90%",
							maxHeight: "90%",
							borderRadius: "8px",
							boxShadow: "0 0 20px rgba(255,255,255,0.2)",
						}}
					/>
					<div
						style={{
							position: "absolute",
							top: "20px",
							right: "30px",
							cursor: "pointer",
						}}
						onClick={() => setSelectedImageUrl(null)}
					>
						<CloseIcon width="2rem" color="white" />
					</div>
				</div>
			)}

			{isLoading && (
                <LoadingScreen />
            )}
		</div>
	);
};

export default SetupAwareness;
